import type { BoggleCompletedRun } from '~/boggle/progress/types'

const ALPHABET_ROWS = [
  'ABCDEFGHI'.split(''),
  'JKLMNOPQR'.split(''),
  'STUVWXYZ'.split(''),
] as const

export { ALPHABET_ROWS }

export function countRunLettersPlayed(run: BoggleCompletedRun): Map<string, number> {
  const counts = new Map<string, number>()
  const timeline = run.acceptedWordTimeline

  if (timeline && timeline.length > 0) {
    for (const fact of timeline) {
      const letters =
        fact.tileLetters.length > 0
          ? fact.tileLetters
          : fact.word.split('')
      for (const letter of letters) {
        const key = letter.toUpperCase()
        if (key.length === 1 && key >= 'A' && key <= 'Z') {
          counts.set(key, (counts.get(key) ?? 0) + 1)
        }
      }
    }
    return counts
  }

  for (const word of run.submittedWords) {
    for (const char of word) {
      const key = char.toUpperCase()
      if (key.length === 1 && key >= 'A' && key <= 'Z') {
        counts.set(key, (counts.get(key) ?? 0) + 1)
      }
    }
  }

  return counts
}
